import styles from "./Results.module.css";
import StyledRadioButton from "../common/inputs/StyledRadioButton";
import classNames from "classnames";

const strings = {
  permissionToDiscuss: "Permission to Discuss",
};

type Props = {
  variant?: "default" | "compact";
  disabled: boolean;
  value: boolean | null;
  onChange: (v: boolean) => void;
};

const options: { value: boolean; label: string }[] = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

export default function PermissionToDiscussFieldset({
  variant = "default",
  disabled,
  value,
  onChange,
}: Props) {
  return (
    <fieldset
      className={classNames({
        [styles.headerFieldset]: true,
        [styles.headerFieldsetSplit]: true,
        [styles.permissionToDiscussFieldset]: true,
        [styles.headerFieldsetWrapped]: variant === "compact",
      })}
    >
      <div
        className={classNames(styles.label, styles.headerLabel)}
        aria-hidden={true}
      >
        {strings.permissionToDiscuss}
      </div>
      <legend className={styles.visuallyHidden}>
        {strings.permissionToDiscuss}
      </legend>
      <div className={styles.radioButtonCol}>
        {options.map((item) => (
          <StyledRadioButton
            key={item.value.toString()}
            disabled={disabled}
            label={item.label}
            value={item.value.toString()}
            checked={value === item.value}
            onChange={() => onChange(item.value)}
            className={styles.radioButton}
          />
        ))}
      </div>
    </fieldset>
  );
}
